/**
 * Checkers Preferences Service
 * Manages user preferences for checkers board styles
 */

import { database } from './firebase';
import { ref, get, set } from 'firebase/database';

// Board style options (using same styles as chess)
export const BOARD_STYLES = [
  {
    id: 'green',
    name: 'Classic Green',
    colors: { light: '#f0d9b5', dark: '#b58863' },
  },
  {
    id: 'brown',
    name: 'Brown Wood',
    colors: { light: '#f0e6d2', dark: '#9b7653' },
  },
  {
    id: 'blue',
    name: 'Ocean Blue',
    colors: { light: '#e8f0f8', dark: '#6b9ac4' },
  },
  {
    id: 'gray',
    name: 'Slate Gray',
    colors: { light: '#d0d0d0', dark: '#808080' },
  },
  {
    id: 'purple',
    name: 'Royal Purple',
    colors: { light: '#e6d5f0', dark: '#9370a8' },
  },
  {
    id: 'red',
    name: 'Traditional Red',
    colors: { light: '#f0d0d0', dark: '#c85050' },
  },
];

// Default preferences
const DEFAULT_PREFERENCES = {
  boardStyle: 'green',
};

/**
 * Get user's checkers preferences from Firebase
 */
export const getCheckersPreferences = async (userId) => {
  try {
    const prefsRef = ref(database, `users/${userId}/preferences/checkers`);
    const snapshot = await get(prefsRef);

    if (snapshot.exists()) {
      return { ...DEFAULT_PREFERENCES, ...snapshot.val() };
    }

    return DEFAULT_PREFERENCES;
  } catch (error) {
    console.error('Error loading checkers preferences:', error);
    return DEFAULT_PREFERENCES;
  }
};

/**
 * Save user's checkers preferences to Firebase
 */
export const saveCheckersPreferences = async (userId, preferences) => {
  try {
    const prefsRef = ref(database, `users/${userId}/preferences/checkers`);
    await set(prefsRef, preferences);
    return true;
  } catch (error) {
    console.error('Error saving checkers preferences:', error);
    throw error;
  }
};

/**
 * Get board colors by style ID
 */
export const getBoardColors = (styleId) => {
  const style = BOARD_STYLES.find((s) => s.id === styleId);
  return style ? style.colors : BOARD_STYLES[0].colors;
};
